import { render, staticRenderFns } from "./IssueRelationModal.vue?vue&type=template&id=4f6c5ade&scoped=true"
import script from "./IssueRelationModal.vue?vue&type=script&lang=js"
export * from "./IssueRelationModal.vue?vue&type=script&lang=js"
import style0 from "./IssueRelationModal.vue?vue&type=style&index=0&id=4f6c5ade&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6c5ade",
  null
  
)

export default component.exports